import { SkeletonBase } from "@components/common/skeletons";
import { cn } from "@lib/utils/cn";

export interface MetricCardSkeletonProps {
  className?: string;
  /** Appends a chart-sized placeholder so loading→ready doesn't jump for cards with a visualization. */
  hasVisualization?: boolean;
}

/**
 * Loading placeholder mirroring a MetricCard in its default variant
 * (migrated from features/rh/components/SkeletonCard.jsx).
 * Announced as a live "loading" region, not decorative.
 */
export function MetricCardSkeleton({
  className,
  hasVisualization = false,
}: MetricCardSkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Chargement"
      className={cn(
        "flex flex-col gap-2.5 rounded-xl bg-[var(--surface)] p-4 shadow-md",
        className,
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <SkeletonBase variant="line" className="h-4 w-32" />
        <SkeletonBase variant="circle" className="h-10 w-10" />
      </div>
      <SkeletonBase variant="line" className="h-8 w-20" />
      <SkeletonBase variant="line" className="h-3 w-24" />
      {hasVisualization && <SkeletonBase variant="line" className="h-14 w-full" />}
    </div>
  );
}
